import { EmitterConfigV3 } from '@pixi/particle-emitter';
import { Texture } from 'pixi.js';

const ParticleSanta: EmitterConfigV3 = {
  lifetime: {
    max: 0.1,
    min: 0.1,
  },
  particlesPerWave: 1,
  frequency: 0.05,
  spawnChance: 1,
  emitterLifetime: -1,
  maxParticles: 500,
  pos: {
    x: 0,
    y: -16,
  },
  emit: false,
  behaviors: [
    {
      type: 'moveSpeedStatic',
      config: {
        min: 10000,
        max: 10000,
      },
    },
    {
      type: 'spawnShape',
      config: {
        type: 'torus',
        data: {
          x: 0,
          y: 0,
          radius: 0,
        },
      },
    },
    {
      type: 'textureRandom',
      config: {
        textures: [
          Texture.from('/textures/objects/projectile/prop_bulb_blue.png'),
          Texture.from('/textures/objects/projectile/prop_bulb_gray.png'),
          Texture.from('/textures/objects/projectile/prop_bulb_green.png'),
          Texture.from('/textures/objects/projectile/prop_bulb_red.png'),
          Texture.from('/textures/objects/projectile/prop_bulb_yellow.png'),
        ],
      },
    },
  ],
};

export default ParticleSanta;
